import clsx from "clsx";

type Props = {
  className?: string;
};
export const TagSmallGroup = ({ className }: Props) => {
  return (
    <p
      className={clsx(
        "rounded-md inset-ring inset-ring-white bg-linear-to-b from-white to-white/75 px-2 py-1.5 font-serif font-medium text-xs/[14px] whitespace-nowrap text-[#1B1511] backdrop-blur-xs [font-feature-settings:'case'_1]",
        className,
      )}
    >
      En petit groupe
    </p>
  );
};
